/*
 * @Date: 2021-05-26 08:51:36
 * @LastEditors: lzq
 * @LastEditTime: 2021-07-07 13:37:30
 * @FilePath: \gxjg-web\plugins\http.js
 * @Annotation: 
 */
import axios from "axios";
// const baseURL = "http://localhost:8099/gxjg"; //本地
const baseURL = "https://www.gxjgjx.cn/gxjg"; //服务器
// const baseURL = "http://jgcs.lzscfc.com/gxjg"; //测试服务器
const http = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  timeout: 60000,
});
const request = (requst) => {
  return http({
    ...requst,
  })
    .then((res) => {
      switch (res.data.code) {
        case 200:
          return res.data;
        case -201:
          return res.data;
          // return Promise.reject(res.data.message);
        default:
          return res.data;
      }
    })
};
export { request, baseURL };
